module.exports = __webpack_public_path__ + "img/spotlight.51e8f87e.jpg";